import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../services/actions';
import styles from './AccueilDashboard.module.scss';

// Import des widgets
import {
  WidgetProjets,
  WidgetAlarmes,
  WidgetContact,
  WidgetRapports,
  WidgetCommentCaMarche,
  WidgetWidgetsLayout,
} from './widgets';

// Composant principal AccueilDashboard
const AccueilDashboard = (props) => {
  const {
    filtre_projects_list_id,
    projects_list,
    favorite_projects_list_id,
    favorite_views_list,
    graphes_favoris,
    alarms_list,
    generates_reports_list,
    dashbords_list_by_user,
    accueil_summary,
    reqRecupererAccueilSummary,
    reqRecupererListeAlarmes,
    reqRecupererListeRapportsGeneres,
    reqRecupererListeGraphes,
    reqRecupererListeVues,
    reqRecupererListeTableauxDeBordFavoris,
  } = props;

  useEffect(() => {
    const projectIds =
      filtre_projects_list_id && filtre_projects_list_id.length > 0
        ? filtre_projects_list_id
        : projects_list?.map((p) => p.project_id) || [];

    if (favorite_projects_list_id && favorite_projects_list_id.length > 0) {
      // Mode "Accueil favoris" : on charge le summary unique
      reqRecupererAccueilSummary();
    } else {
      // Fallback ancienne page d'accueil : appels individuels
      if (projectIds.length > 0) {
        reqRecupererListeAlarmes(projectIds);
        reqRecupererListeRapportsGeneres(projectIds);
        reqRecupererListeGraphes(projectIds);
        reqRecupererListeVues(projectIds);
      }
      reqRecupererListeTableauxDeBordFavoris();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favorite_projects_list_id, filtre_projects_list_id, projects_list]);

  // Données provenant du summary ou fallback sur les listes existantes
  const summary = accueil_summary?.summary || {};
  const alarmesList =
    summary.alarmes ?? (alarms_list ? Object.values(alarms_list).slice(0, 10) : []);
  const rapportsList =
    summary.rapports ?? (generates_reports_list ? Object.values(generates_reports_list).slice(0, 10) : []);
  const dashboardsList =
    summary.dashboard ? [summary.dashboard] : dashbords_list_by_user || [];
  const graphesFavorisList = summary.graph ? [summary.graph] : graphes_favoris || [];
  const vuesFavoritesList = summary.view ? [summary.view] : favorite_views_list || [];
  const projectsListSummary = summary.projects || projects_list || [];

  return (
    <div className={styles.dashboard}>
      <div className={styles.widgetsGrid}>
        <WidgetWidgetsLayout
          dashboards={dashboardsList}
          vuesFavorites={vuesFavoritesList}
          graphesFavoris={graphesFavorisList}
        />
        <div className={[styles.area, styles.projetsArea].join(' ')}>
          <WidgetProjets 
            projects={projectsListSummary}
            favoriteProjectIds={favorite_projects_list_id || []}
          />
        </div>
        <div className={[styles.area, styles.midArea].join(' ')}>
          <div className={styles.midGrid}>
            <div className={styles.midTop}>
              <WidgetAlarmes alarmes={alarmesList} />
            </div>
            <div className={styles.midBottom}>
              <WidgetRapports rapports={rapportsList} />
            </div>
          </div>
        </div>
        <div className={[styles.area, styles.rightArea].join(' ')}>
          <div className={styles.rightGrid}>
            <div className={styles.rightTop}>
              <WidgetContact />
            </div>
            <div className={styles.rightBottom}>
              <WidgetCommentCaMarche />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    prenom: state.authentifie.name,
    user_id: state.authentifie.user_id,
    projects_list: state.authentifie.projects_list,
    favorite_projects_list_id: state.authentifie.favorite_projects_list_id,
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
    
    // Vues
    views_list: state.vue.views_list,
    views_list_by_view_id: state.vue.views_list_by_view_id,
    favorite_views_list: state.vue.favorite_views_list,
    dashbords_list_by_user: state.vue.dashbords_list_by_user,
    accueil_summary: state.accueil,
    
    // Graphes
    graphs_list: state.graphe.graphs_list,
    graphes_favoris: state.graphe.graphes_favoris || [],
    
    // Alarmes
    alarms_list: state.alarme.alarms_list,
    
    // Rapports
    publish_reports_list: state.rapport.publish_reports_list,
    generates_reports_list: state.rapport.generates_reports_list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reqRecupererAccueilSummary: () => dispatch(actions.reqRecupererAccueilSummary()),
    reqRecupererListeAlarmes: (list_project_id) =>
      dispatch(actions.reqRecupererListeAlarmes(list_project_id)),
    reqRecupererListeRapportsGeneres: (list_project_id) =>
      dispatch(
        actions.reqRecupererListeRapportsGeneres({
          list_project_id,
          start_list_generate_report: null,
          end_list_generate_report: null,
        })
      ),
    reqRecupererListeGraphes: (projects_id) =>
      dispatch(actions.reqRecupererListeGraphes(projects_id)),
    reqRecupererListeVues: (list_project_id) =>
      dispatch(actions.reqRecupererListeVues(list_project_id)),
    reqRecupererListeTableauxDeBordFavoris: () =>
      dispatch(actions.reqRecupererListeTableauxDeBordFavoris()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccueilDashboard);
